import React, { Component } from 'react';
import { connect } from 'react-redux';
import { normalize, schema } from 'normalizr';
import {
	loadUnpagedChildLessons, updateChildLesson, generateChildLessons,
	loadWeeklyProgramByCenterAndTerm, addMakeup, markAsPaidMakeup, cancelTrialReservation
} from './actions';
import { loadLessonDates } from '../weeklyPrograms/actions';
import authUtils from '../../auth/utils';
import queryString from 'query-string';
import { withTranslation } from 'react-i18next';
import { Panel, Button, ButtonGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import InfoDialog from './InfoDialog';
import NotesDialog from './NotesDialog';
import EditDialog from './EditDialog';
import NewMakeupDialog from './NewMakeupDialog';
import { loadParentsWithPendingPayment } from '../parents/actions';
import { fetchChild, loadChildrenUnpaged } from '../children/actions';
import { loadPaymentHistoriesUnpaged } from '../paymentHistory/actions';
import AttendanceTable from './Table';
import ViewSwitch from '../../common/components/ViewSwitch';
import DateSelector from '../../common/components/DateSelector';
import ui from '../../common/services/ui';
import utils from '../../common/services/utils';
import {
	sendMessage,
	PARENT_SEND_MESSAGE_REQUEST, PARENT_SEND_MESSAGE_SUCCESS, PARENT_SEND_MESSAGE_FAILURE
} from '../parents/actions';
import SendMessageButton from '../../common/components/message/SendMessageButton';
import moment from 'moment';
import { Checkbox } from 'react-icheck';
import 'icheck/skins/minimal/grey.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faPrint } from '@fortawesome/free-solid-svg-icons';
import { faCalendarDays } from '@fortawesome/free-regular-svg-icons';
import NewEnrolmentButton from './NewEnrolmentButton';
import EnrolmentCount from './EnrolmentCount';
import PrintView from './PrintView';

const AttendanceView = {
	TERM: 'Term',
	DATE: 'Date'
};

class ManageLessonAttendance extends Component {

	constructor(props) {
		super(props);
		this.hideInfo = this.hideInfo.bind(this);
		this.hideNotes = this.hideNotes.bind(this);
		this.hideEdit = this.hideEdit.bind(this);
		this.handleViewSwitch = this.handleViewSwitch.bind(this);
		this.handleDateChange = this.handleDateChange.bind(this);
		this.hideMakeupDialog = this.hideMakeupDialog.bind(this);
		this.handleLessonClick = this.handleLessonClick.bind(this);
		this.handleNewClick = this.handleNewClick.bind(this);
		this.handleNewMakeupClick = this.handleNewMakeupClick.bind(this);
		this.handleParentSelect = this.handleParentSelect.bind(this);
		this.handleChildSelect = this.handleChildSelect.bind(this);
		this.handleGenerateLessons = this.handleGenerateLessons.bind(this);
		this.handleGenerateMakeup = this.handleGenerateMakeup.bind(this);
		this.handleShowInfo = this.handleShowInfo.bind(this);
		this.handleShowNotes = this.handleShowNotes.bind(this);
		this.handleMultipleSelectionChange = this.handleMultipleSelectionChange.bind(this);
		this.handleSendMessage = this.handleSendMessage.bind(this);
		this.handleCancelTrialReservation = this.handleCancelTrialReservation.bind(this);
		this.handlePrint = this.handlePrint.bind(this);
		this.state = {
			showInfo: false,
			showEdit: false,
			showMakeupDialog: false,
			showNotes: false,
			selectedChildren: [],
			withFutureLessonsOnly: false,
			view: ui.isMobileView() ? AttendanceView.DATE : AttendanceView.TERM,
			date: null,
		};
	}

	componentDidMount() {
		this.loadData();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.weeklyProgramItemId !== this.props.weeklyProgramItemId) {
			this.loadData();
			this.setState({ selectedChildren: [], date: null });
		}
	}

	loadData() {
		const {
			loadLessonDates, loadUnpagedChildLessons, loadWeeklyProgramByCenterAndTerm,
			weeklyProgramItemId,
			location: { search }
		} = this.props;
		const { centerId, termId } = queryString.parse(search);

		loadLessonDates(weeklyProgramItemId);
		loadUnpagedChildLessons({ weeklyProgramId: weeklyProgramItemId, canceled: 'false' });

		if (centerId && termId) {
			loadWeeklyProgramByCenterAndTerm(centerId, termId);
		}
	}

	handleViewSwitch(value) {
		this.setState({ view: value });
	}

	handleDateChange(value) {
		this.setState({ date: value });
	}

	handleLessonClick(lesson) {
		const { updateChildLesson } = this.props;
		updateChildLesson(lesson.id, { ...lesson, isAttended: !lesson.isAttended });
	}

	handleNewClick(date) {
		const { loadParents, weeklyProgramItemId } = this.props;
		loadParents({ weeklyProgramItemId });
		this.setState({ showEdit: true, selectedLessonDate: date });
	}

	handleNewMakeupClick(date) {
		this.setState({ showMakeupDialog: true, selectedLessonDate: date });

	}
	handleParentSelect(parentId) {
		const { loadChildren } = this.props;
		loadChildren({ parentId });
	}

	handleGenerateLessons(values) {
		const { paymentHistoryId, notes } = values;
		const { generateChildLessons } = this.props;
		const onSuccessEvent = () => this.hideEdit();
		generateChildLessons({ paymentId: paymentHistoryId, notes }, onSuccessEvent);
	}

	handleGenerateMakeup(values) {
		const { addMakeup, markAsPaidMakeup, weeklyProgramItem, children, fetchChild } = this.props;
		const onSuccessEvent = (result) => markAsPaidMakeup({ paymentId: result.paymentId, isInstalmentPayment: false },
			() => {
				this.loadData();
				this.hideMakeupDialog()
			});
		let child = children[values.childId];
		if (!child) {
			fetchChild(values.childId, () => { child = children[values.childId] });
		}
		addMakeup({
			parentId: child.parentId,
			childId: values.childId,
			programId: weeklyProgramItem.id,
			startDate: this.state.selectedLessonDate,
			paymentType: 6,
			validateChildAge: false
		}, onSuccessEvent
		);
	}

	handleChildSelect(childId, additionalData) {
		const { weeklyProgramItemId, loadPaymentHistories } = this.props;
		const { parentId } = additionalData;
		loadPaymentHistories({ childId, parentId, weeklyProgramItemId, status: 1 });
	}

	handleShowInfo(parent) {
		this.setState({ showInfo: true, selectedParent: parent });
	}

	hideInfo() {
		this.setState({ showInfo: false });
	}

	handleShowNotes(child) {
		this.setState({ showNotes: true, selectedChild: child });
	}

	hideNotes() {
		this.setState({ showNotes: false });
	}

	hideEdit() {
		this.setState({ showEdit: false });
	}

	hideMakeupDialog() {
		this.setState({ showMakeupDialog: false })
	}

	handleMultipleSelectionChange(newSelectedChildren) {
		this.setState({ selectedChildren: newSelectedChildren });
	}

	prepareData() {
		const { parents, children, paymentHistories, weeklyProgramItem } = this.props;
		const { selectedLessonDate } = this.state;
		return {
			parents,
			children,
			paymentHistories,
			weeklyProgramItem,
			lessonDate: selectedLessonDate
		};
	}

	prepareMakeupData() {
		const { weeklyProgramItem } = this.props;
		const { selectedLessonDate } = this.state;
		return {
			weeklyProgramItem,
			lessonDate: selectedLessonDate
		};
	}

	renderPanelHeader() {
		const { weeklyProgramItem, t } = this.props;

		const icon = <FontAwesomeIcon icon={faCalendarDays} />;
		let headerElements = [icon];

		if (weeklyProgramItem) {
			const { center, term, grade, weekday, startTime, endTime } = weeklyProgramItem;
			const timeframe = `${ui.formatTime(startTime)} - ${ui.formatTime(endTime)}`;
			const text = `${center && center.name} · ${term && term.name} · ${weeklyProgramItem.name || (grade && grade.name)} · `;
			const weekDayAndTime = <span key={`date_${weeklyProgramItem.id}`} style={{ fontWeight: 'bold', fontSize: 15 }} dangerouslySetInnerHTML={{ __html: `${weekday && t(ui.days[weekday])} · ${timeframe}` }} />
			const checkboxWithFutureLessonsOnly = <span key={`future_${weeklyProgramItem.id}`} className='pull-right'><Checkbox checkboxClass='icheckbox_minimal-grey bg' increaseArea='20%'
				onChange={(e, checked) => this.handleOnlyFuture(checked)} label={t('LessonAttendance_WithFutureLessonsOnly')} />	</span>;
			headerElements.push(text, weekDayAndTime, checkboxWithFutureLessonsOnly, <div key={`clear_${weeklyProgramItem.id}`} className='clearfix'></div>);
		}

		return headerElements;
	}

	renderAttendanceLink(weeklyProgramItem, linkContent) {
		if (weeklyProgramItem) {
			return <Link key={weeklyProgramItem.id} className='btn btn-default'
				to={`/lessonAttendance/manage?weeklyProgramItemId=${weeklyProgramItem.id}&centerId=${weeklyProgramItem.centerId}&termId=${weeklyProgramItem.termId}`}>
				{linkContent}
			</Link>;
		}

		return <Button bsStyle='default' disabled>{linkContent}</Button>;
	}

	handleSendMessage(values, onSuccess) {
		const selectedParentIds = [...new Set(this.state.selectedChildren.map(child => child.parent.id))];
		this.props.sendMessage({ ...values, parentIds: selectedParentIds }, onSuccess);
	}

	handleCancelTrialReservation(lesson) {
		this.props.cancelTrialReservation(lesson.paymentHistory.id, () => this.loadData());
	}

	normalizeData(children) {
		const parent = new schema.Entity('parents', {}, {
			idAttribute: c => c.id
		});
		const child = new schema.Entity('children', { parent: parent }, {
			idAttribute: p => p.id
		});
		const normalizedData = normalize(children, [child]);
		return normalizedData;
	}

	handleOnlyFuture(checked) {
		this.setState({ withFutureLessonsOnly: checked });
	}

	handlePrint() {
		window.print();
	}

	getCurrentWeekDate(lessonDates) {
		return lessonDates && lessonDates.find(date => moment(date) > moment().startOf('isoWeek') && moment(date) < moment().endOf('isoWeek'));
	}

	getFirstUpcomingDate(lessonDates) {
		const { utcOffset } = this.props;
		return lessonDates && lessonDates.find(date => utils.isUpcomingDate(date, utcOffset));
	}

	render() {
		const { isReadonly, lessonDates, childLessons, t, canAddNewLessons, weeklyProgramItem, nextItem,
			previousItem, enableCollectMedicalInformation, canSendMessage, canViewNotes, utcOffset,
			programCenter, enableTrials, enableMakeUps, canMoveLessons, centerId, termId } = this.props;
		const { showInfo, selectedParent, showEdit, showMakeupDialog } = this.state;
		const data = this.prepareData();
		const header = this.renderPanelHeader();

		const normalizedData = this.normalizeData(this.state.selectedChildren);
		const selectedParents = (normalizedData && normalizedData.entities && normalizedData.entities.parents && Object.values(normalizedData.entities.parents)) || [];

		const childLessonsForTable = childLessons && childLessons.filter(c => !this.state.withFutureLessonsOnly ||
			childLessons.some(l => l.child.id === c.child.id && utils.isUpcomingDate(l.start, utcOffset)));

		const selectedView = this.state.view || AttendanceView.TERM;
		// when the current week has no lesson (holiday) show the first upcoming one, or the last one that took place
		const selectedDate = this.state.date || this.getCurrentWeekDate(lessonDates) || this.getFirstUpcomingDate(lessonDates) ||
			(lessonDates && lessonDates[lessonDates.length - 1]);

		const isSingleDate = selectedView === AttendanceView.DATE || (lessonDates && lessonDates.length === 1);

		const visibleLessonDates = selectedView === AttendanceView.TERM ? lessonDates : (selectedDate ? [selectedDate] : []);
		const visibleChildLessons = selectedView === AttendanceView.TERM ? childLessonsForTable : childLessonsForTable.filter(lesson => moment(lesson.start).isSame(selectedDate, 'day'));

		visibleChildLessons.forEach(lesson => {
			lesson.isLastTrial = lesson.lessonType === 2 && !visibleChildLessons.some(x => x.child.id === lesson.child.id && x.lessonType === lesson.lessonType && moment(x.lessonDate) > moment(lesson.lessonDate));
			lesson.isPackageTrial = lesson.lessonType === 2 && visibleChildLessons.filter(x => x.child.id === lesson.child.id && x.lessonType === lesson.lessonType).length > 1; // more than one trial in package
		});

		return <React.Fragment>
			<PrintView
				weeklyProgramItem={weeklyProgramItem}
				childLessons={visibleChildLessons}
				lessonDates={visibleLessonDates}
				enableCollectMedicalInformation={enableCollectMedicalInformation}
				t={t}
			/>
			<div className='no-print'>
				<div className='clearfix'>
					<Link to='/lessonAttendance' className='btn btn-default mb-1'>{t('Common_BackToList')}</Link>
					{canSendMessage && <SendMessageButton style={{ marginLeft: '5px', marginBottom: '20px' }}
						onSendMessage={this.handleSendMessage}
						to={selectedParents.map(p => ({ name: p.name, email: p.email }))}
						center={programCenter}
						block={PARENT_SEND_MESSAGE_REQUEST}
						unblock={[PARENT_SEND_MESSAGE_SUCCESS, PARENT_SEND_MESSAGE_FAILURE]}
					/>}
					<Button bsStyle='info' className='mb-1' style={{ marginLeft: '5px' }} onClick={this.handlePrint}>
						<FontAwesomeIcon icon={faPrint} /> {t('Attendance_PrintFriendlyVersion')}
					</Button>
					<ButtonGroup className='pull-right mb-1' style={{ marginRight: 10 }}>
						{this.renderAttendanceLink(previousItem, <span><FontAwesomeIcon icon={faAngleDoubleLeft} /> {t('LessonAttendance_Prev')}</span>)}
						{this.renderAttendanceLink(nextItem, <span>{t('LessonAttendance_Next')} <FontAwesomeIcon icon={faAngleDoubleRight} /></span>)}
					</ButtonGroup>
					{lessonDates && lessonDates.length > 1 && <ViewSwitch className='pull-right mb-1' style={{ marginRight: 10 }}
						views={Object.values(AttendanceView).map(x => ({ name: x, label: t(`AttendanceView_${x}`) }))}
						selectedView={selectedView}
						onChange={this.handleViewSwitch}
					/>}
					{selectedView === AttendanceView.DATE && lessonDates && lessonDates.length > 1 && <DateSelector className='pull-right mb-1' style={{ marginRight: 10 }}
						labelPrevious={t('Attendance_PrevDate')} labelNext={t('Attendance_NextDate')}
						dates={lessonDates}
						selectedDate={selectedDate}
						onChange={this.handleDateChange}
					/>}
				</div>
				<Panel>
					<Panel.Heading>{header}</Panel.Heading>
					<Panel.Body>
						{isSingleDate && <div className='clearfix'>
							<div className='clearfix'>
								<h4 style={{ float: 'left' }} className='mr-2'>{ui.customDateFormat(selectedDate, 'LL')}</h4>
								<EnrolmentCount style={{ float: 'left', marginTop: 10 }} className='mr-2'
									date={selectedDate}
									enableTrials={enableTrials}
									enableMakeUps={enableMakeUps}
									childLessons={visibleChildLessons}
									weeklyProgramItem={weeklyProgramItem}
									separator={<span> · </span>}
								/>
								<NewEnrolmentButton
									date={selectedDate}
									enableMakeUps={enableMakeUps}
									onNewClick={this.handleNewClick}
									onNewMakeupClick={this.handleNewMakeupClick}
								/>
							</div>
							{(!visibleChildLessons || visibleChildLessons.length === 0) && <div>{t('Attendance_NoChildLessons')}</div>}
						</div>}
						<AttendanceTable
							isReadonly={isReadonly}
							showHeader={!isSingleDate}
							lessonDates={visibleLessonDates}
							childLessons={visibleChildLessons}
							t={t}
							canAddNewLessons={canAddNewLessons}
							weeklyProgramItem={weeklyProgramItem}
							onLessonClick={this.handleLessonClick}
							onInfoClick={this.handleShowInfo}
							onNotesClick={this.handleShowNotes}
							onNewClick={this.handleNewClick}
							onNewMakeupClick={this.handleNewMakeupClick}
							enableCollectMedicalInformation={enableCollectMedicalInformation}
							selectedChildren={this.state.selectedChildren}
							onMultipleSelectionChange={this.handleMultipleSelectionChange}
							canSendMessage={canSendMessage}
							canViewNotes={canViewNotes}
							canMoveLessons={canMoveLessons}
							centerId={centerId}
							termId={termId}
							onCancelTrialReservation={this.handleCancelTrialReservation}
							enableTrials={enableTrials}
							enableMakeUps={enableMakeUps}
						/>
					</Panel.Body>
				</Panel>
				<InfoDialog show={showInfo} t={t} parent={selectedParent} onHide={this.hideInfo} />
				<EditDialog
					show={showEdit}
					t={t}
					onHide={this.hideEdit}
					onParentSelected={this.handleParentSelect}
					onChildSelected={this.handleChildSelect}
					data={data}
					isReadonly={isReadonly}
					onSubmit={this.handleGenerateLessons}
				/>
				<NewMakeupDialog
					show={showMakeupDialog}
					t={t}
					onHide={this.hideMakeupDialog}
					data={this.prepareMakeupData()}
					isReadonly={isReadonly}
					onSubmit={this.handleGenerateMakeup}
				/>
				<NotesDialog
					show={this.state.showNotes}
					onHide={this.hideNotes}
					t={t}
					child={this.state.selectedChild}
					onNotesUpdated={() => this.loadData()}
				/>
			</div>
		</React.Fragment>;
	}

}


const mapStateToProps = (state, ownProps) => {
	const { weeklyProgramItemId, centerId, termId } = queryString.parse(ownProps.location.search);

	const {
		entities: {
			lessonDates, childLessons, parentsWithPendingPayment, children,
			paymentHistories, weeklyPrograms, centers
		},
		filters: { weeklyProgramByCenterAndTerm },
		configuration: { franchisor },
		auth: { currentUser }
	} = state;

	// Check if the current user has permission to execute and if the franchisor has enabled this action
	const canAddNewLessons = authUtils.hasPermission(currentUser, 'AddNewLessons') &&
		lessonDates[weeklyProgramItemId] && lessonDates[weeklyProgramItemId].addNewLessons;

	const weeklyProgramFilter = weeklyProgramByCenterAndTerm[`${centerId}-${termId}`] || { ids: [] };
	const weeklyProgram = weeklyProgramFilter.ids.map(id => weeklyPrograms[id])
		.sort((a, b) => (a.weekday - b.weekday) || (moment(a.startTime, 'HH:mm') - moment(b.startTime, 'HH:mm')));

	const indexOfItem = weeklyProgram.findIndex(x => x.id === Number(weeklyProgramItemId));
	const nextItem = indexOfItem >= 0 ? weeklyProgram[indexOfItem + 1] : null;
	const previousItem = indexOfItem > 0 ? weeklyProgram[indexOfItem - 1] : null;
	const programLessons = Object.keys(childLessons).map(id => childLessons[id]).filter(lesson => lesson.weeklyProgramItem.id === Number(weeklyProgramItemId));
	const weeklyProgramItem = weeklyPrograms[weeklyProgramItemId];

	return {
		weeklyProgramItemId,
		weeklyProgramItem,
		centerId,
		termId,
		nextItem,
		previousItem,
		childLessons: programLessons,
		lessonDates: lessonDates[weeklyProgramItemId] && lessonDates[weeklyProgramItemId].lessonDates,
		parents: parentsWithPendingPayment,
		children,
		paymentHistories: utils.filter(paymentHistories, h => h.paymentType && h.paymentType.id !== 7), //exclude annual payments
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'ChildLessons'),
		franchisorId: franchisor.id,
		canAddNewLessons,
		enableCollectMedicalInformation: franchisor && franchisor.enableCollectMedicalInformation,
		canSendMessage: franchisor.enableAdHocMessages && authUtils.hasPermission(currentUser, 'SendMessage'),
		canViewNotes: authUtils.hasPermission(currentUser, 'Notes'),
		canMoveLessons: authUtils.hasPermission(currentUser, 'MoveChildLessons') &&
			!authUtils.hasReadOnlyPermission(currentUser, 'MoveChildLessons'),
		utcOffset: franchisor.utcOffsetHours,
		programCenter: weeklyProgramItem && centers[weeklyProgramItem.centerId],
		enableTrials: franchisor.enableTrials,
		enableMakeUps: franchisor.enableMakeUps
	};
};

const mapDispatchToProps = {
	loadUnpagedChildLessons,
	loadLessonDates,
	updateChildLesson,
	loadParents: loadParentsWithPendingPayment,
	loadChildren: loadChildrenUnpaged,
	loadPaymentHistories: loadPaymentHistoriesUnpaged,
	generateChildLessons,
	loadWeeklyProgramByCenterAndTerm,
	sendMessage,
	addMakeup,
	markAsPaidMakeup,
	fetchChild,
	cancelTrialReservation
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ManageLessonAttendance));